import * as STD                            from '@emersya/mpa-std-lib';

import CM                   from '@emersya/mpa-components-manager-lib';
import { Field, InputTextMultiLines } from '@emersya/mpa-components-lib';

export interface IStandingQuestionsComponentConfiguration extends Field.Configuration {
};

export class StandingQuestionsComponent extends Field.Component {
	static override initialize() {
		super.initialize();
	};


	override async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		// await super.onValueUpdated(ev);
		if (ev.details.isDefaultValue) {
			return;
		}
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		;
		if(!app.basket.basket.metaData){
			this.component_throwLibraryError('');
		}
		(<any>app.basket.basket.metaData).customInstructions = ev.details.newValue;
		await <any>void 1;
	};

	override async component_initialize() {
		await this.component_find('@:content').component_instantiateOuterChild({
			type :          'input-textMultiLines',
			isSlot :        false,
			declaredSlot :  null,
			id :            'options',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : <InputTextMultiLines.Configuration> {
				type : 'text'
			}
		});
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		;
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingQuestionsComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});

	};
};
export namespace NS {
	export const Component = StandingQuestionsComponent;
	export type Component = StandingQuestionsComponent;
	export type Configuration = IStandingQuestionsComponentConfiguration;
}
import manifestXMLSource    from './StandingQuestions.xml';
import './StandingQuestions.scss';

CM.declare({
	id :       'standing-questions',
	type :     StandingQuestionsComponent,
	manifest : manifestXMLSource
});
